/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const confirmImageUploadDataCollectionSchema = z.enum(['uploaded'])

export type ConfirmImageUploadDataCollectionSchema = z.infer<typeof confirmImageUploadDataCollectionSchema>
